import React, { Suspense, useContext, useEffect, useState } from "react";
import { Routes, Route, Navigate} from "react-router-dom";
import { Context } from "../../contexts/Store";
import AppRouter from "./AppRouter";
import LoginRouter from "./LoginRouter";
import LoginPage from "../../pages/login";

export default function MainRouter() {
  const [isLoading, setLoading] = useState(true);
  const { dispatch } = useContext(Context);

  async function fetchUserData() {
    let promise = new Promise((resolve, reject) => {
      let user_details = localStorage.getItem("user_details");
      if (!user_details) {
        localStorage.setItem("user_details", JSON.stringify(user_details));
        user_details = localStorage.getItem("user_details");
      }
      let user_details_stored = JSON.parse(user_details);
      dispatch({
        type: "UPDATE_USER_DETAILS",
        user_details: user_details_stored,
      });
      setTimeout(() => {
        resolve("done!");
        setLoading(false);
      }, 500);
    });

    await promise;
  }

  useEffect(() => {
    fetchUserData();
  },[]);

  const { state } = useContext(Context);

  return isLoading ? null : (
    <Suspense fallback={"Loading"}>
      <Routes>
        <Route path="/login" element={ !state.user_details.is_verified ?  <LoginPage/>  : <Navigate to="/" />}/>
        <Route path="/*" element={ state.user_details.is_verified ? <AppRouter/> : <Navigate to="/login" />}/>
      </Routes>
    </Suspense>
  );
}
